var map = {
	"./BearCallSpread.svg": 4984,
	"./BearPutSpread.svg": 5209,
	"./BullCallSpread.svg": 2425,
	"./BullPutSpread.svg": 2026,
	"./Buy.svg": 5717,
	"./ContractIcon.svg": 8100,
	"./Donut.svg": 2393,
	"./ExpansionIcon.svg": 8145,
	"./FeedbackIcon.svg": 297,
	"./Frame.svg": 798,
	"./IronButterfly.svg": 7962,
	"./IronCondor.svg": 7390,
	"./LongStraddle.svg": 4646,
	"./LongStrangle.svg": 2567,
	"./Neutral.svg": 3460,
	"./NoStrategy.svg": 7709,
	"./RatioCallSpread.svg": 3493,
	"./RatioPutSpread.svg": 4062,
	"./Sell.svg": 5811,
	"./Share.svg": 7834,
	"./ShortStraddle.svg": 5460,
	"./ShortStrangle.svg": 8941,
	"./StrategyBuilder.svg": 4309,
	"./StrategyStore.svg": 2843,
	"./add-money.svg": 3471,
	"./additem.svg": 5861,
	"./arrow-square-down.svg": 1051,
	"./arrow-square-up.svg": 2228,
	"./arrow.svg": 7190,
	"./dropdownArrow.svg": 1311,
	"./edit-2.svg": 1610,
	"./fund-circle.svg": 3475,
	"./hamburger.svg": 1180,
	"./info-circle.svg": 3328,
	"./info-circle2.svg": 9330,
	"./logout.svg": 4277,
	"./menu.svg": 2434,
	"./notification-status.svg": 8493,
	"./refresh.svg": 2304,
	"./search-icon.svg": 5691,
	"./search-normal.svg": 6145,
	"./send-2.svg": 9704,
	"./setting-3.svg": 6005,
	"./shopping-cart.svg": 5302,
	"./symbols_save.svg": 5198,
	"./tick-circle-gray.svg": 2335,
	"./tick-circle-green.svg": 5123,
	"./tick-circle.svg": 8181,
	"./toolsFooter.svg": 2657,
	"./trash.svg": 6891,
	"./userSetting.svg": 3030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;